// Shared formatting + filter helpers for the admin Server Console
// (AdminActivityLogView and its row/filter subcomponents).

export const DUTCH_DAYS = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
export const DUTCH_MONTHS = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

/** The console's filter state — shared by the view and the filter bar. */
export interface LogFilters {
  method: string;
  user: string;
  type: 'all' | 'requests' | 'actions' | 'errors';
  statusClass: '' | '4xx' | '5xx';
  status: string;
  from: string;
  to: string;
}

export const EMPTY_LOG_FILTERS: LogFilters = {
  method: '',
  user: '',
  type: 'all',
  statusClass: '',
  status: '',
  from: '',
  to: '',
};

export function hasActiveFilters(f: LogFilters): boolean {
  return Boolean(f.method || f.user || f.type !== 'all' || f.statusClass || f.status || f.from || f.to);
}

export function methodColor(method?: string): string {
  switch (method) {
    case 'GET': return 'bg-gray-100 text-gray-600';
    case 'POST': return 'bg-blue-100 text-blue-700';
    case 'PATCH': return 'bg-amber-100 text-amber-700';
    case 'DELETE': return 'bg-red-100 text-red-700';
    default: return 'bg-gray-100 text-gray-500';
  }
}

export function statusColor(status?: number): string {
  if (!status) return 'bg-gray-100 text-gray-500';
  if (status < 300) return 'bg-green-100 text-green-700';
  if (status < 400) return 'bg-blue-100 text-blue-700';
  if (status < 500) return 'bg-amber-100 text-amber-700';
  return 'bg-red-100 text-red-700';
}

export function moduleColor(module?: string): string {
  switch (module) {
    case 'planning': return 'bg-blue-100 text-blue-700';
    case 'easykit': return 'bg-purple-100 text-purple-700';
    case 'photos': return 'bg-green-100 text-green-700';
    case 'installer': return 'bg-orange-100 text-orange-700';
    case 'admin': return 'bg-red-100 text-red-700';
    default: return 'bg-gray-100 text-gray-600';
  }
}

export function levelColor(level?: string): string {
  switch (level) {
    case 'warn': return 'bg-amber-100 text-amber-700';
    case 'fatal': return 'bg-red-200 text-red-800';
    default: return 'bg-red-100 text-red-700';
  }
}

/** Mirror the API's status filter for client-side SSE entries. Exact code wins. */
export function matchesStatusFilter(
  status: number | undefined,
  statusClass: '' | '4xx' | '5xx',
  exact: string,
): boolean {
  if (exact) return status === Number(exact);
  if (!statusClass) return true;
  if (typeof status !== 'number') return false;
  const lo = statusClass === '4xx' ? 400 : 500;
  return status >= lo && status <= lo + 99;
}

export function formatLogTime(ts: string): string {
  return new Date(ts).toLocaleTimeString('nl-BE', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}
